export default __webpack_public_path__ + "static/media/photo_gallery_7.25ea145c.png";